import { AvailableModules, Features } from 'generated/featureDefinitions'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { ProjectsUpsellRequestSources } from '../constants'
import { useCreateUpsellNotificationMessage } from '../hooks/useCreateUpsellNotificationMessage'

interface RequestUpgradeModalProps {
  onClose: () => void
}

export const UpsellProjectsBulkActionsModal = ({ onClose }: RequestUpgradeModalProps) => {
  const { sendUpsellNotificationMessage } = useCreateUpsellNotificationMessage()

  const onCloseUpsellModal = () => {
    track(trackingEvents.projectManagement.bulkActions.upgrade.cancelUpgradeModal)
    onClose()
  }

  const onSuccessNotify = async () => {
    sendUpsellNotificationMessage(ProjectsUpsellRequestSources.bulkActions)

    track(trackingEvents.projectManagement.bulkActions.upgrade.confirmUpgradeModal)
    onClose()
  }

  return (
    <RequestUpgradeModal
      moduleRequested={AvailableModules.projects}
      requestSource={ProjectsUpsellRequestSources.bulkActions}
      requestReason={ValidReasons.MissingAddon}
      featureRequested={Features.projects_bulk_actions}
      onClose={onCloseUpsellModal}
      onSuccess={onSuccessNotify}
    />
  )
}
